/* import __COLOCATED_TEMPLATE__ from './projected-conversations-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    ranking: ProjectedConversationsRanking;
  };
}

export default class ProjectedConversationsStamp extends Component<Signature> {
  @service declare intl: IntlService;

  get rankingTitle(): string {
    if (this.args.ranking === ProjectedConversationsRanking.High) {
      return this.intl.t('ai-agent.suggestions.list-item.projected-conversations-ranking.high');
    }
    if (this.args.ranking === ProjectedConversationsRanking.Medium) {
      return this.intl.t('ai-agent.suggestions.list-item.projected-conversations-ranking.medium');
    }
    return this.intl.t('ai-agent.suggestions.list-item.projected-conversations-ranking.low');
  }

  get rankingStyling() {
    if (this.args.ranking === ProjectedConversationsRanking.High) {
      return 'bg-vis-mantis-40 text-on-success';
    }
    if (this.args.ranking === ProjectedConversationsRanking.Medium) {
      return 'bg-vis-mantis-70 text-success';
    }
    return 'bg-vis-mantis-80 text-success';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ProjectedConversationsStamp': typeof ProjectedConversationsStamp;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/projected-conversations-stamp': typeof ProjectedConversationsStamp;
  }
}
